module.exports = __webpack_public_path__ + "media/images/comments-fe6ce0ea6f022ccad1ed4a358dab8e9e.jpg";